import React, { FC, useCallback } from 'react';
import css from './calendar.module.css';
import { AnimalEvent } from '../../../../../../interfaces/animal-event';
import EventItem from '../event-item';
import { AnimalEventStatus } from '../../../../../../enums/animal-event-status';
import './calendar.css';
import { useTranslation } from 'react-i18next';
interface Props {
  onClick?: () => void;
  children?: React.ReactNode;
  className?: string;
  day?: number;
  isActive?: boolean;
  events?: AnimalEvent[];
  hasWeek?: boolean;
  weekName?: string;
  frame?: string;
}

const Cell: FC<Props> = ({
  onClick,
  children,
  className = '',
  day,
  isActive = false,
  events = [],
  hasWeek = false,
  weekName = '',
  frame = null,
}) => {
  const active = isActive ? css['active-cell'] : '';
  const frameCss = frame != null ? css['missed-cell'] : '';
  const classNames = `${className} ${css['basic-cell']} ${active} ${frameCss} calendar_day__${day}`;
  const { t } = useTranslation();
  const transKeyPrefix = 'pages.livestock.animals_and_events.animals.types.';
  const tp = useCallback((key: string) => t(transKeyPrefix.concat(key)), [t]);

  const getEventStatus = (event: AnimalEvent) => {
    const todayOnlyDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    );
    if (String(event.status) === AnimalEventStatus.COMPLETE) {
      return AnimalEventStatus.COMPLETE;
    } else if (new Date(event.date) < todayOnlyDate) {
      return AnimalEventStatus.FAILED;
    } else {
      return AnimalEventStatus.PLANNED;
    }
  };
  return (
    <div className={classNames} onClick={onClick}>
      <div className={'flex justify-between'}>
        <div className={css['day-text']}>{day}</div>
        {hasWeek && <div className={css['week-text']}>{weekName}</div>}
      </div>
      <div>
        {children}
        {events.length > 0 && (
          <div className="events">
            {events.map((event, index) => (
              <EventItem
                key={index}
                name={tp(event.type)}
                type={event.type}
                count={event.animals.length}
                status={getEventStatus(event)}
                event={event}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Cell;
